<div class="not-found-container">
	<section class="content-section">
		<img src="/assets/images/svg/404-not-found-image.svg" alt="Imagem de erro 404" loading="lazy" />
		<span>Lo sentimos, la página que está buscando no se encuentra disponible. =/</span>
		<button class="btn btn-primary" [routerLink]="['/']">Ir a home</button>
	</section>

	<section class="car-image-section">
		<img src="/assets/images/jpg/not-found-car-image.jpg" alt="Imagem de carro" loading="lazy" />
	</section>
</div>
